import React from "react";

export default ({ data }) => {
	return (
		<>
			<h2 style={{ marginTop: "0", marginBottom: "7.5px" }}>{data.total}</h2>
			<p style={{ marginTop: "0", paddingTop: "0" }}>
				2026-2027 Donations to Date
			</p>
		</>
	);
};
